export default {
    methods: {
        processItem(item) {
            if (this.$store.state.user.event_ecosystems_names?.length) {
                return item.replace('{ecosystems}', this.$store.state.user.event_ecosystems_names?.map(item => item + "'s").join(', '))
            } else {
                return item.replace('{ecosystems}', '');
            }
        }
    }
}
